import { render, staticRenderFns } from "./returnDistributionMap.vue?vue&type=template&id=142b9b84&scoped=true"
import script from "./returnDistributionMap.vue?vue&type=script&lang=js"
export * from "./returnDistributionMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142b9b84",
  null
  
)

export default component.exports